import axiosInstance from "api/axiosInstance";

import type { PracticeSchedule, PracticeScheduleCreateRequest, PracticeScheduleListParams } from "api/types/practice-schedules.types";

const BASE = "/server/buccl_lessons/api/v1/practice-schedules/";

export const practiceSchedulesService = {
  list: (params?: PracticeScheduleListParams) => axiosInstance.get<PracticeSchedule[]>(BASE, { params }),

  get: (id: number) => axiosInstance.get<PracticeSchedule>(`${BASE}${id}/`),

  create: (payload: PracticeScheduleCreateRequest) => axiosInstance.post<PracticeSchedule>(BASE, payload),

  update: (id: number, payload: Partial<PracticeScheduleCreateRequest>) => axiosInstance.patch<PracticeSchedule>(`${BASE}${id}/`, payload),

  complete: (id: number) => axiosInstance.post(`${BASE}${id}/complete/`),

  convertToPaid: (scheduleId: number, payload: { price: number; discount_price?: number | null }) => axiosInstance.post(`${BASE}${scheduleId}/convert-to-paid/`, payload),
};
